export default __webpack_public_path__ + "static/media/seleccionados_queretaro2026.eb4b19ee.pdf";